import { addYears, differenceInCalendarDays, getYear, toDate } from 'date-fns';
import { parseISO } from 'date-fns/parseISO';
import { format as formatDate } from 'date-fns/format';
export { default as createAutoCorrectedDatePipe } from './createAutoCorrectedDatePipe';
// TODO: check related jira https://jira.etraveli.net/browse/WEB-3016
const getLocale = languageCode => {
  switch (languageCode) {
    case 'no':
      return 'nb';
    case 'zh':
      return 'zhCN';
    case 'ar':
      return 'arSA';
    default:
      return languageCode;
  }
};

/**
 * Accepts either an options object or a bare language code.
 *
 * TODO: the bare-string form never resolves a locale. The original JS read
 * `options.locale`, which is always undefined on a string, so callers passing a
 * language code directly (my-bookings/utils/orderCardUtils) silently fall back to
 * English. Preserved as-is to keep the TypeScript migration behaviour-neutral.
 */
export const getLazyLocale = async options => {
  const localeCode = typeof options === 'string' ? undefined : options === null || options === void 0 ? void 0 : options.locale;
  let locale;
  if (localeCode && localeCode !== 'en') {
    try {
      const tempLocale = getLocale(localeCode);
      const locales = await import(`date-fns/locale`);
      locale = locales[tempLocale];
    } catch (err) {
      console.error(err); // oxlint-disable-line no-console
    }
  }
  return locale;
};
export const createFormatter = async (options = {}) => {
  const locale = await getLazyLocale(options);
  const formatter = {
    format: (date, string, opts) => formatDate(date, string, {
      ...opts,
      locale
    })
  };
  global.etiDateFormatter = formatter;
  return formatter;
};
const isValidDate = date => !Number.isNaN(date.getTime());
export const convertToDate = dateValue => typeof dateValue === 'string' ? parseISO(dateValue) : toDate(dateValue);
export const format = (dateValue, ...rest) => {
  const date = convertToDate(dateValue);
  if (!isValidDate(date)) {
    return 'Invalid Date';
  }
  return global.etiDateFormatter ? global.etiDateFormatter.format(date, ...rest) : formatDate(date, ...rest);
};
export const durationInDays = (fromDate, untilDate) => differenceInCalendarDays(untilDate, fromDate);
export const getExpiryDateConstraints = (baseDate, passportExpiryMaxFutureYears = 10) => ({
  minYear: getYear(baseDate),
  maxYear: getYear(addYears(baseDate, passportExpiryMaxFutureYears)),
  minMonth: 0
});
export const getBirthDateConstraints = baseDate => ({
  minYear: 1900,
  maxYear: getYear(baseDate),
  minMonth: 1
});
//# sourceMappingURL=index.js.map